export default "__VITE_PUBLIC_ASSET__94e36259__"